export default "__VITE_ASSET__R2nbcAsJ5OYlRa80zecvlQ__";